<template>
    <div>
        <!-- Start Hero -->
        <Head title="Home" />
        <section class="relative table w-full py-36 lg:py-36">
            <div class="container">
                <div class="grid md:grid-cols-12 grid-cols-1 items-center mt-10 gap-[30px]">
                    <div class="md:col-span-7">
                        <div class="md:mr-6">
                            <h4 class="font-semibold lg:leading-normal leading-normal text-4xl lg:text-5xl mb-5 text-black dark:text-white" v-html="sanitizeHtml(html.sections[0].title)"></h4>
                            <p class="text-slate-400 text-lg max-w-xl" v-html="sanitizeHtml(html.sections[0].details)"></p>

                            <div class="mt-6">
                                <Link v-for="(button, bi) in html.sections[0].buttons" :key="bi" :href="button.link" class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md mr-2 mt-2" :class="{'bg-transparent hover:bg-indigo-600 border-indigo-600 text-indigo-600 hover:text-white': bi === 1}"> {{ button.text }}</Link>
                            </div>
                        </div>
                    </div><!--end col-->

                    <div class="md:col-span-5">
                        <img v-if="html.sections[0].image" :src="html.sections[0].image" alt="">
                        <img v-else src="/landing/images/svg/working-process.svg" alt="">
                    </div><!--end col-->
                </div><!--end grid-->
            </div><!--end container-->
        </section><!--end section-->
        <!-- End Hero -->

        <section class="relative md:py-24 py-16 bg-gray-50 dark:bg-slate-800">
            <div class="container">
                <div class="grid grid-cols-1 pb-8 text-center wow animate__animated animate__fadeInUp" data-wow-delay=".1s">
                    <h3 class="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold" v-html="sanitizeHtml(html.sections[4].title)"></h3>

                    <p class="text-slate-400 max-w-xl mx-auto" v-html="sanitizeHtml(html.sections[4].details)"></p>
                </div><!--end grid-->

                <div class="grid md:grid-cols-12 grid-cols-1 gap-[30px] mt-8">
                    <div v-for="(feature, fi) in html.sections[4].feature_list" :key="fi" class="lg:col-span-4 md:col-span-6 wow animate__animated animate__fadeInUp" data-wow-delay=".1s">
                        <div class="flex transition-all duration-500 hover:scale-105 shadow dark:shadow-gray-800 hover:shadow-md dark:hover:shadow-gray-700 ease-in-out items-center p-3 rounded-md bg-white dark:bg-slate-900">
                            <div class="flex items-center justify-center h-[45px] min-w-[45px] bg-gradient-to-r from-transparent to-indigo-600/10 text-indigo-600 text-center rounded-full ltr:mr-3 rtl:ml-3">
                                {{ feature.number }}
                            </div>
                            <div class="flex-1">
                                <h4 class="mb-0 text-lg font-normal">{{ feature.text }}</h4>
                            </div>
                        </div>
                    </div>
                </div><!--end grid-->
            </div><!--end contanier-->
        </section>

        <!-- Start -->
        <section class="relative md:py-24 py-16">
            <!-- new code -->
            <div class="container md:mt-24 mt-16">
                <div class="grid md:grid-cols-12 grid-cols-1 items-center gap-[30px]">
                    <div class="md:col-span-5">
                        <div class="relative">
                            <img v-if="html.sections[1].image" :src="html.sections[1].image" alt="">
                            <img v-else src="/images/svg/doctor-appointment.svg" alt="">
                        </div>
                    </div><!--end col-->

                    <div class="md:col-span-7">
                        <div class="ltr:lg:ml-8 rtl:lg:mr-8">
                            <h4 class="mb-6 md:text-3xl text-2xl lg:leading-normal leading-normal font-medium" v-html="sanitizeHtml(html.sections[1].title)"></h4>
                            <p class="text-slate-400 max-w-xl" v-html="sanitizeHtml(html.sections[1].details)"></p>
                            <div class="mt-6">
                                <Link v-for="(button, bi) in html.sections[1].buttons" :key="bi" :href="button.link" class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md mr-2 mt-2" :class="{'bg-transparent hover:bg-indigo-600 border-indigo-600 text-indigo-600 hover:text-white': bi === 1}"> {{ button.text }}</Link>
                            </div>
                        </div>
                    </div><!--end col-->
                </div><!--end grid-->
            </div><!--end container-->
            <!-- new code -->
        </section>
        <section class="relative md:py-24 py-16 bg-gray-50 dark:bg-slate-800">
            <!-- new code -->
            <div class="container md:mt-24 mt-16">
                <div class="grid md:grid-cols-12 grid-cols-1 items-center gap-[30px]">
                    <div class="md:col-span-7">
                        <div class="ltr:lg:ml-8 rtl:lg:mr-8">
                            <h4 class="mb-6 md:text-3xl text-2xl lg:leading-normal leading-normal font-medium" v-html="sanitizeHtml(html.sections[2].title)"></h4>
                            <p class="text-slate-400 max-w-xl" v-html="sanitizeHtml(html.sections[2].details)"></p>
                            <div class="mt-6">
                                <Link v-for="(button, bi) in html.sections[2].buttons" :key="bi" :href="button.link" class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md mr-2 mt-2" :class="{'bg-transparent hover:bg-indigo-600 border-indigo-600 text-indigo-600 hover:text-white': bi === 1}"> {{ button.text }}</Link>
                            </div>
                        </div>
                    </div><!--end col-->

                    <div class="md:col-span-5">
                        <div class="relative">
                            <img v-if="html.sections[2].image" :src="html.sections[2].image" alt="">
                            <img v-else src="/images/svg/lawyers-appointment.svg" alt="">
                        </div>
                    </div><!--end col-->

                </div><!--end grid-->
            </div><!--end container-->
            <!-- new code -->
        </section>
        <section class="relative md:py-24 py-16">
            <!-- new code -->
            <div class="container md:mt-24 mt-16">
                <div class="grid md:grid-cols-12 grid-cols-1 items-center gap-[30px]">
                    <div class="md:col-span-5">
                        <div class="relative">
                            <img v-if="html.sections[3].image" :src="html.sections[3].image" alt="">
                            <img v-else src="/images/svg/interior-design.svg" alt="">
                        </div>
                    </div><!--end col-->

                    <div class="md:col-span-7">
                        <div class="ltr:lg:ml-8 rtl:lg:mr-8">
                            <h4 class="mb-6 md:text-3xl text-2xl lg:leading-normal leading-normal font-medium" v-html="sanitizeHtml(html.sections[3].title)"></h4>
                            <p class="text-slate-400 max-w-xl" v-html="sanitizeHtml(html.sections[3].details)"></p>
                            <div class="mt-6">
                                <Link v-for="(button, bi) in html.sections[3].buttons" :key="bi" :href="button.link" class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md mr-2 mt-2" :class="{'bg-transparent hover:bg-indigo-600 border-indigo-600 text-indigo-600 hover:text-white': bi === 1}"> {{ button.text }}</Link>
                            </div>
                        </div>
                    </div><!--end col-->

                </div><!--end grid-->
            </div><!--end container-->
            <!-- new code -->
        </section>
        <!-- End -->
        <!-- Start -->
        <section class="relative md:py-24 py-16 bg-gray-50 dark:bg-slate-800">
            <div class="container md:mt-24 mt-16 md:mb-12">
                <div class="grid grid-cols-1 text-center">
                    <h3 class="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold" v-html="sanitizeHtml(html.sections[5].title)"></h3>

                    <p class="text-slate-400 max-w-xl mx-auto" v-html="sanitizeHtml(html.sections[5].details)"></p>

                    <div class="mt-6">
                        <Link v-for="(button, bi) in html.sections[5].buttons" :key="bi" :href="button.link" class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md mr-2 mt-2" :class="{'bg-transparent hover:bg-indigo-600 border-indigo-600 text-indigo-600 hover:text-white': bi === 1}"> {{ button.text }}</Link>
                    </div>
                </div><!--end grid-->
            </div><!--end container-->
        </section><!--end section-->
        <div class="relative">
            <div class="shape absolute right-0 sm:-bottom-px -bottom-[2px] left-0 overflow-hidden z-1 text-dark-footer">
                <svg class="w-full h-auto" viewBox="0 0 2880 250" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M720 125L2160 0H2880V250H0V125H720Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
        <!-- End -->

    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Logo from '@/Shared/Logo'
import Layout from '@/Shared/Landing/Layout'
import Icon from '@/Shared/Icon'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import sanitizeHtml from "sanitize-html";
export default {
    metaInfo: { title: 'Home' },
    layout: Layout,
    components: {
        Logo,
        Icon,
        LoadingButton,
        SelectInput,
        TextInput,
        Head,
        Link,
    },
    props: {
        categories: Array,
        departments: Array,
        types: Array,
        title: String,
        page: Object,
    },
    remember: 'form',
    data() {
        return {
            html: JSON.parse(this.page.html),
            form: this.$inertia.form({
                first_name: '',
                last_name: '',
                email: '',
                department_id: null,
                category_id: null,
                type_id: null,
                subject: null,
                details: '',
                files: [],
            }),
            sanitizeHtml : sanitizeHtml
        }
    },

    methods: {
        store() {
            this.form.post(this.route('ticket_store'),{
                onSuccess: () => {
                    this.form.reset()
                },
                // form.reset()
            })
        },
        fileInputChange(e) {
            let selectedFiles = e.target.files;
            for (let i = 0; i < selectedFiles.length; i++) {
                this.form.files.push(selectedFiles[i]);
            }
        },
        fileRemove(image, index) {
            this.form.files.splice(index, 1);
        },
        getFileSize(size) {
            const i = Math.floor(Math.log(size) / Math.log(1024))
            return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
        },
        fileBrowse() {
            this.$refs.file.click()
        },
    },
    created() {
    }
}
</script>




